import React from 'react';
import { Button } from '../ui/button';
import { Calculator, CheckCircle2, ArrowRight, TrendingDown } from 'lucide-react';

const BULLETS = [
  'Compare 6 cenários: Pessoa Física, Simples (com e sem Fator R), Lucro Presumido, SUP e Equiparação Hospitalar',
  'Resultado imediato, gratuito e baseado nas tabelas vigentes',
  'Veja em reais quanto você pode economizar por mês e por ano',
];

export const CalculatorSection = ({ onOpen }) => {
  return (
    <section className="py-10 md:py-14 lg:py-16 bg-slate-900 relative overflow-hidden" data-testid="calculator-section">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#007f73]/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#1e4e7e]/30 blur-3xl" />
      <div className="container-apex relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#5cc1b0] font-medium mb-3 text-sm uppercase tracking-wider flex items-center gap-2">
              <Calculator className="w-4 h-4" />
              Ferramenta gratuita
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              Quanto você está pagando de imposto <span className="text-[#5cc1b0]">a mais</span>?
            </h2>
            <p className="text-slate-300 text-lg mb-6 leading-relaxed">
              Em menos de 1 minuto, descubra qual regime tributário é o mais econômico para o seu
              faturamento — e quanto você pode economizar por ano.
            </p>
            <ul className="space-y-3 mb-8">
              {BULLETS.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-300">
                  <CheckCircle2 className="w-5 h-5 text-[#5cc1b0] mt-0.5 flex-shrink-0" />
                  <span className="text-sm md:text-base">{b}</span>
                </li>
              ))}
            </ul>
            <Button
              onClick={onOpen}
              className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-md px-8 py-6 text-base font-semibold"
              data-testid="open-calculator-button"
            >
              <Calculator className="mr-2 h-5 w-5" />
              Calcular meus impostos agora
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>

          <div className="relative hidden lg:block">
            <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-8">
              <div className="flex items-center justify-between mb-6">
                <p className="text-white font-heading font-bold text-lg">Simulação exemplo</p>
                <TrendingDown className="w-6 h-6 text-emerald-400" />
              </div>
              <div className="space-y-3">
                {[
                  { name: 'Pessoa Física', value: 'R$ 21.400/mês', pct: 92 },
                  { name: 'Lucro Presumido', value: 'R$ 13.900/mês', pct: 60 },
                  { name: 'Simples Nacional (Fator R)', value: 'R$ 10.400/mês', pct: 45 },
                  { name: 'Equiparação Hospitalar', value: 'R$ 8.100/mês', pct: 35, best: true },
                ].map((r, i) => (
                  <div key={i} className={`rounded-lg p-3 ${r.best ? 'bg-emerald-500/20 border border-emerald-400/40' : 'bg-white/5'}`}>
                    <div className="flex justify-between text-sm mb-1.5">
                      <span className={r.best ? 'text-emerald-300 font-semibold' : 'text-slate-300'}>{r.name}</span>
                      <span className={r.best ? 'text-emerald-300 font-bold' : 'text-slate-300'}>{r.value}</span>
                    </div>
                    <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${r.best ? 'bg-emerald-400' : 'bg-slate-500'}`} style={{ width: `${r.pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-center text-emerald-300 font-semibold mt-6 text-sm">
                Economia identificada: R$ 159.600/ano
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
